import dedent from 'dedent';
import { lazy } from 'react';
import Footer from './footer/Footer';
import Header from './header/Header';
import Callables from './layout/Callables';
import SkipLinks from './layout/SkipLinks';
import { DynamicOpeningHoursCard } from './sanity/components/HomePageCards';
import { DraftModeLoader } from './sanity/infrastructure/detectSanityPresentationMode';

export type Components = Record<string, React.ComponentType<any>>;

const clientComponents: Components = {
    Header,
    Footer,
    SkipLinks,
    DraftModeLoader,
    Callables,
    DynamicOpeningHoursCard,
    TableOfContents: lazy(() => import('./sanity/components/TableOfContents')),
    ScrollTracker: lazy(() => import('./layout/ScrollTracker')),
    OnlineLaunchSignup: lazy(() => import('./sanity/components/OnlineLaunchSignup')),
    // Add new client components here
};

export function getComponent(name: string) {
    if (name in clientComponents) return clientComponents[name];

    throw new Error(dedent`
        Could not find component '${name}' in 'clientComponents', did you forget to add it?
        It is defined as
        \`\`\`
        const clientComponents: Components = {
            ${Object.keys(clientComponents).join(',\n            ')}
        };
        \`\`\`
    `);
}

/**
 * This is called by the page chunks, adding their own page specific chunk to the clientComponents
 * so that the DOMContentLoaded event listener below can use it
 */
export function defineClientComponent(name: string, component: React.ComponentType) {
    clientComponents[name] = component;
}
